import { createSelector } from 'reselect';

const getResendEmailAttempting = (state) => state.layout.attempting;
const getResendEmailSuccess = (state) => state.layout.resendEmail;
const getResendEmailError = (state) => state.layout.errorCode;

export const getResendEmailAttemptingSelector = createSelector(getResendEmailAttempting, (attempting) => attempting);
export const getResendEmailSuccessSelector = createSelector(getResendEmailSuccess, (resendEmail) => resendEmail);
export const getResendEmailErrorSelector = createSelector(getResendEmailError, (errorCode) => errorCode);
